import { BetData, SportCompetitor } from "@fresh8/types/src/betData";
import { Sport } from "@fresh8/types/src/language";
// import mockJSON from "../../mocks/mocks-sportradar.json";
import { formatOdds } from "@fresh8/ad-data-composition/src/lib/formatOdds";
import { oddsTypeEnum } from "@fresh8/types/src";

// export type SportradarData = typeof mockJSON;
// type SportradarEvent = typeof mockJSON.events[0];

const colorSet = { base: "", number: "" };

function convertOdds(odds: string): [number, number] {
  // fixing the parsed float to 2 decimal places
  // prepending with "+" to convert back to a number.
  const oddsFloat = +odds - 1;
  if (oddsFloat < 1) {
    // converting the fraction into something that looks
    // more appealing e.g 1/9.09 instead of 0.11/1
    const converted = 1 / oddsFloat;
    return [1, +converted.toFixed(2)];
  }
  return [+oddsFloat.toFixed(2), 1];
}

function srEventsReducer(betDataAccumulator: BetData, currEvent: any): BetData {
  const { eventData } = currEvent;

  const awayCompetitor: SportCompetitor = {
    name: {
      full: eventData.team_away_name,
      short: eventData.team_away_name,
      micro: eventData.team_away_name_short
    },
    badge: eventData.team_away_logo,
    colors: { home: colorSet, away: colorSet, third: colorSet }
  };

  const homeCompetitor: SportCompetitor = {
    name: {
      full: eventData.team_home_name,
      short: eventData.team_home_name,
      micro: eventData.team_home_name_short
    },
    badge: eventData.team_home_logo,
    colors: { home: colorSet, away: colorSet, third: colorSet }
  };

  const marketId = `${eventData.eventId}_${currEvent.eventType}`;

  if (!betDataAccumulator.events) betDataAccumulator.events = {};

  betDataAccumulator.events[eventData.eventId] = {
    id: eventData.eventId,
    sport: eventData.sport as Sport,
    normalisedCompetition: eventData.tournament_name,
    competition: eventData.tournament_name,
    name: `${eventData.team_home_name} vs ${eventData.team_away_name}`,
    eventUrl: eventData.stemmedUrl,
    fixture: eventData.scheduled,
    live: false,
    competitors: {
      away: awayCompetitor,
      home: homeCompetitor
    },
    markets: [marketId]
  };

  if (!betDataAccumulator.markets) betDataAccumulator.markets = {};

  betDataAccumulator.markets[marketId] = {
    marketType: "Match Winner",
    marketId,
    eventId: eventData.eventId,
    marketName: currEvent.eventType,
    promoMarketName: "",
    options: [`${marketId}_1`, `${marketId}_2`, `${marketId}_3`]
  };

  const awayOdds = convertOdds(eventData.odds.away);
  const drawOdds = convertOdds(eventData.odds.draw);
  const homeOdds = convertOdds(eventData.odds.home);

  if (!betDataAccumulator.options) betDataAccumulator.options = {};

  betDataAccumulator.options[`${marketId}_1`] = {
    id: `${marketId}_1`,
    label: "away",
    suspended: false,
    odds: awayOdds,
    wasOdds: [0, 0],
    betslipUrl: eventData.stemmedUrl,
    meta: "",
    name: awayCompetitor.name,
    oddsAmerican: formatOdds(awayOdds, oddsTypeEnum.AMERICAN_ODDS),
    promoText: "",
    marketID: marketId
  };

  betDataAccumulator.options[`${marketId}_2`] = {
    id: `${marketId}_2`,
    label: "draw",
    suspended: false,
    odds: drawOdds,
    wasOdds: [0, 0],
    betslipUrl: eventData.stemmedUrl,
    meta: "",
    name: awayCompetitor.name,
    oddsAmerican: formatOdds(drawOdds, oddsTypeEnum.AMERICAN_ODDS),
    promoText: "",
    marketID: marketId
  };

  betDataAccumulator.options[`${marketId}_3`] = {
    id: `${marketId}_3`,
    label: "home",
    suspended: false,
    odds: homeOdds,
    wasOdds: [0, 0],
    betslipUrl: eventData.stemmedUrl,
    meta: "",
    name: awayCompetitor.name,
    oddsAmerican: formatOdds(homeOdds, oddsTypeEnum.AMERICAN_ODDS),
    promoText: "",
    marketID: marketId
  };

  if (!betDataAccumulator.analytics) {
    betDataAccumulator.analytics = {
      url: "",
      emit: false,
      viewId: "",
      userId: "",
      creativeType: "",
      adServingBehaviour: "",
      adtagId: "",
      brandId: "",
      catalogueId: ""
    };
  }

  if (!betDataAccumulator.operator) {
    betDataAccumulator.operator = {
      name: "fresh8",
      friendlyName: "fresh8",
      _id: ""
    };
  }
  return betDataAccumulator;
}

export default (data: any): BetData => {
  const betData = data.events.reduce(srEventsReducer, {} as BetData);
  console.log("SR_DATA", data);
  console.log("MAPPED_DATA", betData);
  return betData;
};
